// Auth0 configuration with custom domain for login UI
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN || '';
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENTID || '';
// CRITICAL: Must use TENANT domain audience (not custom domain)
// Even with custom domain, audience must be tenant-based for Management API
export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE || '';